export default __webpack_public_path__ + "clientRoot/Static/CarglassLogo/Carglass-Logo.png";